import { render } from "./ShoppingCartList.vue?vue&type=template&id=b3f38c0c"
import script from "./ShoppingCartList.vue?vue&type=script&lang=js"
export * from "./ShoppingCartList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__